import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-437c2285"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "alerts" }
const _hoisted_2 = {
  key: 0,
  class: "successGreen"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "gfx/check.svg",
  class: "big"
}, null, -1))
const _hoisted_4 = {
  key: 1,
  class: "errorRed"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "gfx/exclamation.svg",
  class: "big"
}, null, -1))
const _hoisted_6 = {
  key: 2,
  class: "warningOrange"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "gfx/warning.svg",
  class: "big"
}, null, -1))
const _hoisted_8 = {
  key: 3,
  class: "infoBlue"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "gfx/info-circle-o.svg",
  class: "big"
}, null, -1))
const _hoisted_10 = {
  key: 4,
  class: "green"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "alertIcon" }, [
  /*#__PURE__*/_createElementVNode("img", { src: "gfx/check.svg" })
], -1))
const _hoisted_12 = { class: "successText" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cleaner" }, null, -1))
const _hoisted_14 = {
  key: 5,
  class: "red"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "alertIcon" }, [
  /*#__PURE__*/_createElementVNode("img", { src: "gfx/exclamation.svg" })
], -1))
const _hoisted_16 = { class: "errorText" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cleaner" }, null, -1))
const _hoisted_18 = {
  key: 6,
  class: "orange"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "alertIcon" }, [
  /*#__PURE__*/_createElementVNode("img", { src: "gfx/warning.svg" })
], -1))
const _hoisted_20 = { class: "warningText" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cleaner" }, null, -1))
const _hoisted_22 = {
  key: 7,
  class: "blue"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "alertIcon" }, [
  /*#__PURE__*/_createElementVNode("img", { src: "gfx/info-circle-o.svg" })
], -1))
const _hoisted_24 = { class: "infoText" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cleaner" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.priority == 1 && !_ctx.msg)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createTextVNode(_toDisplayString(_ctx.title), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.priority == 2 && !_ctx.msg)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _hoisted_5,
          _createTextVNode(_toDisplayString(_ctx.title), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.priority == 3 && !_ctx.msg)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _hoisted_7,
          _createTextVNode(_toDisplayString(_ctx.title), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.priority == 4 && !_ctx.msg)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _hoisted_9,
          _createTextVNode(_toDisplayString(_ctx.title), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.priority == 1 && _ctx.msg)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("h3", null, _toDisplayString(_ctx.title), 1),
            _createElementVNode("p", null, _toDisplayString(_ctx.msg), 1)
          ]),
          _hoisted_13
        ]))
      : _createCommentVNode("", true),
    (_ctx.priority == 2 && _ctx.msg)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _hoisted_15,
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("h3", null, _toDisplayString(_ctx.title), 1),
            _createElementVNode("p", null, _toDisplayString(_ctx.msg), 1)
          ]),
          _hoisted_17
        ]))
      : _createCommentVNode("", true),
    (_ctx.priority == 3 && _ctx.msg)
      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
          _hoisted_19,
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("h3", null, _toDisplayString(_ctx.title), 1),
            _createElementVNode("p", null, _toDisplayString(_ctx.msg), 1)
          ]),
          _hoisted_21
        ]))
      : _createCommentVNode("", true),
    (_ctx.priority == 4 && _ctx.msg)
      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
          _hoisted_23,
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("h3", null, _toDisplayString(_ctx.title), 1),
            _createElementVNode("p", null, _toDisplayString(_ctx.msg), 1)
          ]),
          _hoisted_25
        ]))
      : _createCommentVNode("", true)
  ]))
}